<div class="tw:items-center error-text tw:flex tw:flex-col tw:w-full tw:max-w-7xl tw:mx-auto tw:px-4 tw:h-full">
  <span class="error-img tw:mt-96 tw:mb-40" data-testid="error-img" title="Service unavailable"></span>
  <span class="tw:mb-24" i18n>The service is temporarily unavailable. Please try again later.</span>
  <span class="tw:mb-40" data-testid="service-unavailable" role="note" i18n
    >Please go to
    <a href="https://status.visma.com" role="link" rel="noreferrer noopener" target="_blank">Visma status page</a>
    to see updates on the issue status</span
  >
</div>
